import { render, staticRenderFns } from "./MPopupDomainConnectCheckFail.vue?vue&type=template&id=18de9382&"
import script from "./MPopupDomainConnectCheckFail.vue?vue&type=script&lang=ts&"
export * from "./MPopupDomainConnectCheckFail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports